import { useEffect, useState } from "react";
import { matchPath, useLocation } from "react-router-dom";

import { PATHS_TO_HIDE } from "components/Layout/constants";
import { routePaths } from "routes/constants";

export const useHideTopNavBar = () => {
  const location = useLocation();
  const [isHideTopNavBar, setIsHideTopNavBar] = useState(false);

  useEffect(() => {
    const pathsToHide = PATHS_TO_HIDE.map((item) => {
      return item.href;
    });
    const pathName = location.pathname;
    const isNavbarHidden = pathsToHide.some((path) =>
      matchPath({ path: path, end: true }, pathName || "")
    );

    setIsHideTopNavBar(
      isNavbarHidden && location.pathname !== routePaths.root.root
    );
  }, [location.pathname]);

  return {
    isHideTopNavBar,
  };
};
